<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/library/meters">Измерители</router-link>
          <span></span>
          <h1>Создание измерителя</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="block_flex">
          <div class="left">
            <div class="folder radius">
              <div class="column caption">
                <p>Основные настройки</p>
              </div>
              <div class="column">
                <div class="content">
                  <form-input name="title"></form-input>
                  <form-input name="url"></form-input>
                  <form-drop-down title="title" name="author_id" :id="parentId.authors"
                                  :url="apiUrls.content"></form-drop-down>
                  <form-input name="alt"></form-input>
                  <form-file use-case="cover" name="img"></form-file>
                  <div class="list">
                    <p>Настройки отображения</p>
                    <div class="checkbox-group">
                      <checkbox name="show_author"></checkbox>
                      <checkbox name="show_date"></checkbox>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="right">
            <div class="folder radius">
              <div class="column caption">
                <p>СЕО настройки</p>
              </div>
              <div class="column">
                <div class="content">
                  <form-input name="seo_title"></form-input>
                  <form-text-area name="seo_desc"></form-text-area>
                  <form-text-area name="seo_key"></form-text-area>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onAddItem">Сохранить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import Checkbox from '@/components/create-form/Checkbox'
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('mainPage')

  export default {
    data: function () {
      return {
        editorInstance: '',
        isLoaded: false,
        text: '',
        editor: null,
        editorConfig: {
          language: 'ru',
          ckfinder: {
            uploadUrl: this.$store.state.apiDomain + this.$store.state.ckfinderUrl,
            token: localStorage.token
          }
        }
      }
    },
    computed: {
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      },
      ...mapState([
        'textContent',
        'fields'
      ]),
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
        'addToNews'
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setCurrentParentId',
        'setFileExtensions',
        'setUrl'
      ]),
      onAddItem () {
        this.addItem()
          .then(() => {
            this.$router.push('/library/meters')
          })
      },
    },
    created () {
      this.setUrl(this.apiUrls.content)
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.setCurrentParentId(this.parentId.library.meters)
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Название измерителя',
          errorId: null,
          errors: {empty: 'Введите название измерителя'},
          tabId: 0
        },
        url: {
          value: '',
          parameterName: 'url',
          name: 'Ссылка',
          errorId: null,
          errors: {unique: 'Ссылка должна быть уникальной'},
          tabId: 0,
          isNullable: true
        },
        author_id: {
          value: '',
          parameterName: 'author_id',
          name: 'Автор статьи',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Выберите автора'},
          tabId: 0,
        },
        show_author: {
          value: true,
          parameterName: 'show_author',
          name: 'Отображать автора',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        show_date: {
          value: true,
          parameterName: 'show_date',
          name: 'Отображать дату',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        alt: {
          value: '',
          parameterName: 'alt',
          name: 'Alt',
          errorId: null,
          type: 'object',
          errors: {empty: 'Напишите краткое описание картинки'},
          tabId: 0,
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
        seo_title: {
          value: '',
          parameterName: 'seo_title',
          name: 'Название страницы',
          errorId: null,
          errors: {empty: 'Напишите название страницы'},
          tabId: 0
        },
        seo_key: {
          value: '',
          parameterName: 'seo_key',
          name: 'Ключевые слова',
          errorId: null,
          errors: {empty: 'Напишите ключевые слова'},
          tabId: 0,
          isNullable: true
        },
        seo_desc: {
          value: '',
          parameterName: 'seo_desc',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        },
      })
    },
    components: {
      Checkbox,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/library/meters/pages/Create.vue